import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'initializers/types';

import { fetchSchedule } from 'features/scheduleBuilder/ScheduleBuilderView/actions/shared';

import { captureHydrationException, getSliceState } from '../helpers';

import { SLICE_NAME } from './constants';
import type {
  CustomJobPosition,
  CustomJobPositionSerializedEntity,
  CustomJobPositionsState,
} from './types';

export const customJobPositionsAdapter =
  createEntityAdapter<CustomJobPosition>();

const initialState: CustomJobPositionsState = {
  ...customJobPositionsAdapter.getInitialState(),
  status: 'idle',
  error: undefined,
};

export const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setAll: customJobPositionsAdapter.setAll,
    removeAll: customJobPositionsAdapter.removeAll,
  },
  extraReducers: builder => {
    builder.addCase(fetchSchedule.fulfilled, (state, action) => {
      state.status = 'succeeded';
      if (action.payload?.included) {
        try {
          const customJobPositions: CustomJobPosition[] = (
            action.payload.included as CustomJobPositionSerializedEntity[]
          )
            .filter(
              (entity: CustomJobPositionSerializedEntity) =>
                entity.type === 'customJobPosition'
            )
            .map((entity: CustomJobPositionSerializedEntity) => ({
              id: entity.id,
              type: entity.type,
              position: entity.attributes.position,
            }));
          customJobPositionsAdapter.setAll(state, customJobPositions);
        } catch (error) {
          captureHydrationException(state, error, SLICE_NAME);
        }
      }
    });
  },
});

export const {
  selectIds: selectCustomJobPositionsIds,
  selectAll: selectAllCustomJobPositions,
} = customJobPositionsAdapter.getSelectors<RootState>(
  state => getSliceState(state)?.[SLICE_NAME] || initialState
);

export const { setAll, removeAll } = slice.actions;
export const { reducer } = slice;
